var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            flex: "1",
            display: "flex",
            "flex-direction": "column"
          }
        },
        [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "7px", "padding-bottom": "7px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "addContractNo",
                        type: "primary",
                        disabled: !_vm.$checkPermission([
                          "button_TabFclContractNoPrice_add"
                        ])
                      },
                      on: { click: _vm.addContractNo }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddContractNo")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_TabFclContractNoPrice_publish"],
                          expression: "['button_TabFclContractNoPrice_publish']"
                        }
                      ],
                      attrs: {
                        no: "updateReleaseState",
                        disabled:
                          !_vm.fcl.up.selectedRow ||
                          !!_vm.fcl.up.selectedRow.releaseState,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.updateReleaseState(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Publish")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_TabFclContractNoPrice_cancelPublish"],
                          expression:
                            "['button_TabFclContractNoPrice_cancelPublish']"
                        }
                      ],
                      attrs: {
                        no: "updateReleaseState",
                        disabled:
                          !_vm.fcl.up.selectedRow ||
                          !_vm.fcl.up.selectedRow.releaseState,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.updateReleaseState(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelPublishment")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "101405",
                  "grid-params": _vm.fcl.up.girdParams,
                  "grid-options": _vm.fcl.up.gridOptions,
                  "column-defs": _vm.fcl.up.columnDefs,
                  "row-data": _vm.fcl.up.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.fcl.up, "girdParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.fcl.up, "girdParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.fcl.up.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section", staticStyle: { flex: "1" } },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "7px", "padding-bottom": "7px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "save",
                        type: "primary",
                        disabled: !_vm.$checkPermission([
                          "button_TabFclContractNoPrice_save"
                        ])
                      },
                      on: { click: _vm.addContractPrice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "edit",
                        type: "primary",
                        disabled: _vm.fcl.down.rowData.length === 0
                      },
                      on: { click: _vm.batchEditSurcharge }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.BulkUpdateSurcharge")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "grid-params": _vm.fcl.down.girdParams,
                  "grid-options": _vm.fcl.down.gridOptions,
                  "column-defs": _vm.fcl.down.columnDefs,
                  "row-data": _vm.fcl.down.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.fcl.down, "girdParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.fcl.down, "girdParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.fcl.down.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm.dialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.dialog.visible,
                title: _vm.$t("CargoMsg.Cargo_AddContractNo"),
                width: "800px",
                "close-on-click-modal": false,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.dialog, "visible", $event)
                },
                close: _vm.closeDialog
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ShippingCompanyContractNo"
                                    ),
                                    required: ""
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "scno",
                                      disabled:
                                        !_vm.dialog.isEdit ||
                                        _vm.dialog.step === 2,
                                      filterable: "",
                                      "default-value":
                                        _vm.dialog.scno || undefined,
                                      cache: false,
                                      "tag-name": "scno",
                                      "tag-value": "scno",
                                      "filter-type": "global",
                                      "filter-tag-names": ["scno"],
                                      "static-options": _vm.dialog.scnoList
                                    },
                                    on: { parentCallBack: _vm.onScNoChange }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.InnerContractNo"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "innerContractNo",
                                      disabled:
                                        !_vm.dialog.isEdit ||
                                        _vm.dialog.step === 2,
                                      filterable: "",
                                      "default-value":
                                        _vm.dialog.contractNo || undefined,
                                      cache: false,
                                      "tag-name": "innerContractNo",
                                      "tag-value": "innerContractNo",
                                      "filter-type": "global",
                                      "filter-tag-names": ["innerContractNo"],
                                      "static-options":
                                        _vm.dialog.contractNoList
                                    },
                                    on: {
                                      parentCallBack: function(item) {
                                        return (_vm.dialog.contractNo =
                                          item.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_EffectiveDate"
                                    ),
                                    required: ""
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "beginDate",
                                      disabled:
                                        !_vm.dialog.isEdit ||
                                        _vm.dialog.step === 2,
                                      editable: false,
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                      "picker-options": _vm.pickerOptions
                                    },
                                    model: {
                                      value: _vm.dialog.beginDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dialog, "beginDate", $$v)
                                      },
                                      expression: "dialog.beginDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_InvalidDate"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "endDate",
                                      disabled:
                                        !_vm.dialog.isEdit ||
                                        _vm.dialog.step === 2,
                                      editable: false,
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                      "picker-options": _vm.pickerOptions
                                    },
                                    model: {
                                      value: _vm.dialog.endDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dialog, "endDate", $$v)
                                      },
                                      expression: "dialog.endDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dialog.step === 2,
                          expression: "dialog.step===2"
                        }
                      ],
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px",
                        "font-size": "14px",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.defaultMarkupRange")))]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dialog.step === 2,
                          expression: "dialog.step===2"
                        }
                      ],
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "addDefaultPrice",
                            type: "primary",
                            disabled: !_vm.$checkPermission([
                              "button_TabFclContractNoPrice_priceAdd"
                            ])
                          },
                          on: { click: _vm.addDefaultPrice }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "deleteDefaultPrice",
                            type: "danger",
                            disabled: !_vm.$checkPermission([
                              "button_TabFclContractNoPrice_priceDelete"
                            ])
                          },
                          on: { click: _vm.deleteDefaultPrice }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dialog.step === 2,
                          expression: "dialog.step===2"
                        }
                      ],
                      staticClass: "section",
                      staticStyle: { flex: "1" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "grid-params": _vm.dialog.girdParams,
                          "grid-options": _vm.dialog.gridOptions,
                          "column-defs": _vm.dialogColumnDefs,
                          "row-data": _vm.dialog.rowData,
                          "show-side-bar": false
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(_vm.dialog, "girdParams", $event)
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(_vm.dialog, "girdParams", $event)
                          },
                          gridReady: function(params) {
                            _vm.dialog.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dialog.step === 2,
                          expression: "dialog.step===2"
                        }
                      ],
                      staticStyle: { float: "left" },
                      attrs: { no: "back" },
                      on: { click: _vm.previousStep }
                    },
                    [_vm._v(_vm._s(_vm.$t("Menu.Back")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dialog.step === 1,
                          expression: "dialog.step===1"
                        }
                      ],
                      attrs: { no: "next", type: "primary" },
                      on: { click: _vm.nextStep }
                    },
                    [_vm._v(_vm._s(_vm.$t("Menu.Next")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dialog.step === 2,
                          expression: "dialog.step===2"
                        }
                      ],
                      attrs: { no: "save", type: "primary" },
                      on: { click: _vm.checkSaveContractNo }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "cancel" }, on: { click: _vm.closeDialog } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.copyDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.copyDialog.visible,
                title: _vm.$t("SeaExport.copyAndAddPoItems"),
                width: "400px",
                "close-on-click-modal": false,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.copyDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ShippingCompanyContractNo"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "scno",
                                      disabled: true,
                                      filterable: "",
                                      "default-value":
                                        _vm.copyDialog.scno || undefined,
                                      cache: false,
                                      "tag-name": "scno",
                                      "tag-value": "scno",
                                      "filter-type": "global",
                                      "filter-tag-names": ["scno"],
                                      "static-options": _vm.copyDialog.scnoList
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.copyDialog.scno = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.InnerContractNo"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "contractNo",
                                      filterable: "",
                                      "default-value":
                                        _vm.copyDialog.contractNo || undefined,
                                      cache: false,
                                      "tag-name": "innerContractNo",
                                      "tag-value": "innerContractNo",
                                      "filter-type": "global",
                                      "filter-tag-names": ["innerContractNo"],
                                      "static-options":
                                        _vm.copyDialog.contractNoList
                                    },
                                    on: {
                                      parentCallBack: function(item) {
                                        return (_vm.copyDialog.contractNo =
                                          item.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Pricing.BeginDate"),
                                    required: ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: {
                                          width: "100%",
                                          "margin-right": "2px"
                                        },
                                        attrs: {
                                          no: "beginDate2",
                                          editable: false,
                                          type: "date",
                                          "value-format": "yyyy-MM-dd",
                                          "picker-options": _vm.pickerOptions
                                        },
                                        model: {
                                          value: _vm.copyDialog.beginDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.copyDialog,
                                              "beginDate",
                                              $$v
                                            )
                                          },
                                          expression: "copyDialog.beginDate"
                                        }
                                      }),
                                      _vm._v("- "),
                                      _c("el-date-picker", {
                                        staticStyle: {
                                          width: "100%",
                                          "margin-left": "2px"
                                        },
                                        attrs: {
                                          no: "endDate2",
                                          editable: false,
                                          type: "date",
                                          "value-format": "yyyy-MM-dd",
                                          "picker-options": _vm.pickerOptions
                                        },
                                        model: {
                                          value: _vm.copyDialog.endDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.copyDialog,
                                              "endDate",
                                              $$v
                                            )
                                          },
                                          expression: "copyDialog.endDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "confirm", type: "primary" },
                      on: { click: _vm.toCopy }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel2" },
                      on: {
                        click: function($event) {
                          _vm.copyDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("contract-No-surcharge-fcl-dialog", {
        attrs: {
          visible: _vm.contractNoSurchargeFclDialog.visible,
          title: _vm.contractNoSurchargeFclDialog.title,
          "contract-no-price": _vm.contractNoSurchargeFclDialog.contractNoPrice,
          "begin-date": _vm.contractNoSurchargeFclDialog.beginDate,
          "end-date": _vm.contractNoSurchargeFclDialog.endDate,
          "is-batch": _vm.contractNoSurchargeFclDialog.isBatch,
          "contract-no-price-keys":
            _vm.contractNoSurchargeFclDialog.contractNoPriceKeys
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.contractNoSurchargeFclDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }